// Форматирование времени
export const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}; 
// Форматирование времени для списка чатов
export const formatChatTime = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  if (date >= today) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (date >= yesterday) {
    return 'Вчера';
  } else {
    return date.toLocaleDateString([], { day: 'numeric', month: 'short' });
  }
};
// Форматирование заголовка даты
export const formatDateHeader = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const twoDaysAgo = new Date(today);
  twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
  
  // Сравниваем даты без времени
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
  const twoDaysAgoOnly = new Date(twoDaysAgo.getFullYear(), twoDaysAgo.getMonth(), twoDaysAgo.getDate());
  
  if (dateOnly.getTime() === todayOnly.getTime()) {
    return 'Сегодня';
  } else if (dateOnly.getTime() === yesterdayOnly.getTime()) {
    return 'Вчера';
  } else if (dateOnly.getTime() === twoDaysAgoOnly.getTime()) {
    return 'Два дня назад';
  } else {
    // Форматируем дату: 15 мая 2026
    return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
  }
};
// Форматирование статуса "был(а) в сети"
export const formatLastSeen = (lastSeen) => {
  if (!lastSeen) return 'был(а) давно';
  
  const now = new Date();
  const last = new Date(lastSeen);
  const diffMs = now - last;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'только что';
  if (diffMins < 60) return `был(а) ${diffMins} мин. назад`;
  if (diffHours < 24) return `был(а) ${diffHours} ч. назад`;
  return `был(а) ${diffDays} д. назад`;
};
// Форматирование размера файла
export const formatFileSize = (bytes) => {
      if (bytes === 0) return '0 Б';
      const k = 1024;
      const sizes = ['Б', 'КБ', 'МБ', 'ГБ'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

// Форматирование секунд в формат ММ:СС (например, 75 -> 01:15)
export const formatDuration = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    
    // Метод padStart(2, '0') добавляет ноль впереди, если цифра одна (например, "5" -> "05")
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
    
    return `${paddedMinutes}:${paddedSeconds}`;
};